import React from 'react';
import { bool, number } from 'prop-types';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { formatAsPositivePoundsOrPence } from 'utils/currency';
import GoToTrolley from 'components/GoToTrolley';
import { useMinSpend } from 'hooks/use-min-spend';
import classNames from 'classnames';
import TrolleyButtonContents from './TrolleyButtonContents';

import styles from './ShoppingSummary.scss';

const ShoppingSummary = ({
  loadingStatus = false,
  totalEstimatedCost = 0,
  totalNumberOfItems = 0,
  isMobile = false,
  scrolled = false,
}) => {
  const estimatedCost = formatAsPositivePoundsOrPence(totalEstimatedCost);
  const description = `trolley, ${totalNumberOfItems} item${
    totalNumberOfItems !== 1 ? 's' : ''
  } ${estimatedCost} total, view trolley.`;

  const { showMinSpend, minSpend } = useMinSpend();

  return (
    <div className={styles.shoppingSummary}>
      <section
        className={styles.trolleyActions}
        data-actiontype="redirect"
        data-customdata="category:Header"
        data-origincomponent="ShoppingSummary"
        data-shortdescription={description}
      >
        <GoToTrolley
          className={classNames(styles.trolleyLink)}
          data-testid="header-trolley-link"
          label={estimatedCost}
          originComponent="site-header accessible trolley link"
          title={description}
        >
          <TrolleyButtonContents
            estimatedCost={estimatedCost}
            loadingStatus={loadingStatus}
            totalNumberOfItems={totalNumberOfItems}
          />
        </GoToTrolley>
        <div
          className={classNames(styles.minSpendWrap, {
            [styles.show]: showMinSpend,
            [styles.hide]: !showMinSpend,
            [styles.scrolled]: scrolled,
          })}
        >
          <Typography
            styleAs={!isMobile ? 'paragraphSmall' : 'paragraphExtraSmall'}
            textStyle={!isMobile ? 'body-s' : 'body-xs'}
          >
            {!isMobile ? 'Minimum' : 'Min.'}{' '}
            <span className="sr-only">{isMobile ? 'Min.' : ''} order</span> £{minSpend}
          </Typography>
        </div>
      </section>
    </div>
  );
};

ShoppingSummary.propTypes = {
  loadingStatus: bool,
  totalEstimatedCost: number,
  totalNumberOfItems: number,
  isMobile: bool,
};

export default ShoppingSummary;
